import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-12-kartikey-hariyani-guest.webp";
import ThumbImg from "../../assets/images/conversations/012.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: cz-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .cz-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .cz-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .cz-hero { padding-top: 60px; padding-bottom: 60px; }
  .cz-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .cz-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .cz-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .cz-hero__title.cz-visible { opacity: 1; transform: translateY(0); }
  .cz-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .cz-hero__spotify.cz-visible { opacity: 1; transform: translateY(0); }
  .cz-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .cz-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .cz-hero__right.cz-visible { opacity: 1; transform: translateY(0); }

  .cz-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .cz-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .cz-yt-thumb:hover img { opacity: 0.85; }
  .cz-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .cz-yt-thumb__play img { width: 40px; height: 44px; }
  .cz-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .cz-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .cz-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .cz-body.cz-visible { opacity: 1; transform: translateY(0); }
  .cz-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .cz-body__para:last-child { margin-bottom: 0; }

  .cz-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .cz-guest.cz-visible { opacity: 1; transform: translateY(0); }
  .cz-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .cz-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .cz-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .cz-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .cz-inner { padding-left: 32px; padding-right: 32px; }
    .cz-hero { padding-top: 32px; padding-bottom: 48px; }
    .cz-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .cz-hero__title { font-size: 24px; }
    .cz-hero__left { gap: 16px; }
    .cz-guest__title { font-size: 24px; margin-bottom: 24px; }
    .cz-guest__photo-bg { width: 260px; height: 300px; }
    .cz-guest__name { font-size: 24px; margin-top: 18px; }
    .cz-body__para { font-size: 14px; margin-bottom: 12px; }
    .cz-body { padding-bottom: 48px; }
    .cz-guest { padding-bottom: 48px; }
    .cz-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .cz-inner { padding-left: 16px; padding-right: 16px; }
    .cz-hero { padding-top: 51px; padding-bottom: 30px; }
    .cz-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .cz-hero__left { gap: 30px; }
    .cz-hero__title { font-size: 30px; }
    .cz-body__para { font-size: 16px; margin-bottom: 10px; }
    .cz-guest__title { font-size: 30px; margin-bottom: 20px; }
    .cz-guest__photo-bg { width: 100%; height: 386px; }
    .cz-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .cz-body { padding-bottom: 30px; }
    .cz-guest { padding-bottom: 30px; }
    .cz-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("cz-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP12_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="cz-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 12 Chargezone"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="cz-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 12 Chargezone thumbnail" />
      <div className="cz-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="cz-hero">
      <div className="cz-inner">
        <div className="cz-hero__grid">
          <div className="cz-hero__left">
            <h1 ref={titleRef} className="cz-hero__title">
              EP 12 | Which comes first... the infrastructure or the EVs | Chargezone
            </h1>
            <div ref={spotifyRef} className="cz-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/2wPit1alRZfkc2zScddZk2?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 12 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="cz-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="cz-body">
      <div className="cz-inner">
        <p className="cz-body__para">
          Range anxiety is one of the primary causes of dissonance in the minds of potential buyers of Electric Vehicles and it always ends up with the same chicken and egg story. Which comes first? Electric Vehicles or long distances charging infrastructures.
        </p>
        <p className="cz-body__para">
          Fast chargers are expensive and yet without the network, only the early adoptive adventure seekers will lean towards driving an Electric Vehicle. Charge-point operators or put more simply companies that invest in the infrastructure to provide EV users with the ability to charge at multiple locations will play a very important role globally not just in India in facilitating the penetration of EV's to the point that they are ubiquitous in our lives.
        </p>
        <p className="cz-body__para">
          The CPO space globally is made up of either the nimble or very fast-growing start-ups or the other end of the spectrum large investments made by power utility companies to ensure they can keep or sequester this sector directly for themselves.
        </p>
        <p className="cz-body__para">
          In India, we are yet to see how this will play out and the market is experiencing so very exciting investments right now. Some 40 start-ups are already operating in the country as CPOs. But, will Reliance create a Jio wave in this sector as well? Will Adani come to dominate it soon? That's what we need to find out.
        </p>
        <p className="cz-body__para">
          In this episode, we explore the CPO sector in India and speak with Kartikey Hariyani the founder and Managing Director of one of India's largest charge point operators CHARGE+ZONE.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="cz-guest">
      <div className="cz-inner">
        <h2 className="cz-guest__title">Our Guest</h2>
        <div>
          <div className="cz-guest__photo-bg">
            <img src={GuestImg} alt="Kartikey Hariyani" />
          </div>
          <p className="cz-guest__name">Kartikey HARIYANI</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep12Chargezone() {
  return (
    <>
      <style>{CSS}</style>
      <div className="cz-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}